import axios from "axios";
import ApiService from "./api.service";

/*
 * Okno wizualizacji pod stałym linkiem odpytuje serwer cyklicznie i działa bez obsługi (ekran na sali),
 * więc jego żądania - stan okna i style (custom.css.service) - omijają globalne interceptory axiosa: tam 403
 * przenosi na stronę logowania, a inne błędy pokazują komunikaty, które trzeba zamknąć. Odpowiedzi i błędy
 * obsługuje wywołujący.
 */
export const visualizationClient = axios.create({
    baseURL: "/",
    headers: { Accept: "application/json" }
});

class PublicService extends ApiService {
    getPublicSession(code, lang) {
        return this.get(`api/meeting/public/sessions/${code}?lang=${lang}`);
    }

    getVisualizationSession(councilId, code, lang) {
        return visualizationClient.get(`api/meeting/public/visualization/${encodeURIComponent(councilId)}/${encodeURIComponent(code)}`, { params: { lang } });
    }

    getOverlaySession(transmissionCode, lang) {
        return this.get(`api/meeting/public/overlay/${transmissionCode}?lang=${lang}`);
    }

    getFile(ssoToken) {
        return this.get(`api/meeting/public/attachments?token=${ssoToken}`, { responseType: "arraybuffer" });
    }

    getDataForVotingPublic(ssoToken, lang) {
        return this.get(`api/voting/public/visualisation?tk=${ssoToken}&lang=${lang}`);
    }

    getPublicSessionInfo(code, lang) {
        return this.get(`api/meeting/public/sessions/information/${code}?lang=${lang}`);
    }

    downloadAttachmentPublicInfo(data) {
        return this.post(`api/meeting/public/attachments`, data, { responseType: "arraybuffer" });
    }

    getVotingInteractiveDataForResults(data) {
        return this.post(`api/voting/public/results/data`, data)
    }

    getVotingsSummaryResults(data) {
        return this.post(`api/voting/public/results/summary`, data)
    }
}

export default new PublicService();
